import { AbstractControl, ValidationErrors } from '@angular/forms';

// Mesma parte local do `Validators.email` do Angular, menos o `*`, e com domínio obrigatoriamente
// com ponto (como a regex que o cadastro PF já usava).
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

/**
 * APR-3701: o autofill do Edge chegou a preencher "E-mail" e "Confirmar e-mail" com o texto de
 * exibição mascarado (`di*******@hotmail.com`). O `Validators.email` aceita `*` na parte local,
 * então a conta era criada com um e-mail que não existe. `*` é válido pela RFC 5322, mas nenhum
 * provedor usado pelos requerentes o emite; aqui ele é tratado como e-mail mascarado.
 */
export function isValidEmail(value: string | null | undefined): boolean {
  if (!value) return false;
  return EMAIL_REGEX.test(value.trim());
}

/** Validator de formulário. Campo vazio fica com o `Validators.required`. */
export function strictEmailValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  return isValidEmail(control.value) ? null : { email: true };
}
